import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function two_column_content() {
  gsap.registerPlugin(ScrollTrigger);

  const sections = document.querySelectorAll(".two_column_content");

  sections.forEach((section) => {
    const titleArea = section.querySelector(".title_area");
    const heading = titleArea?.querySelector("h2");
    const paragraph = titleArea?.querySelector("p");

    if (!heading || !paragraph) return;

    if (
      heading.querySelector("span.letter") ||
      paragraph.querySelector("span.letter")
    )
      return;

    // --- Split letters for animation
    const wrapLetters = (el) => {
      const letters = el.textContent.trim().split("");
      el.innerHTML = letters
        .map((letter) => `<span class="letter">${letter}</span>`)
        .join("");
      return el.querySelectorAll(".letter");
    };

    const h2Letters = wrapLetters(heading);
    const pLetters = wrapLetters(paragraph);

    // --- Animate heading
    gsap.fromTo(
      h2Letters,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        stagger: 0.05,
        duration: 1.5,
        scrollTrigger: {
          trigger: section,
          start: "top 80%", // start earlier (e.g. when top hits 80% of viewport)
          end: "top 50%",
          scrub: true,
        },
      }
    );

    // --- Animate paragraph
    gsap.fromTo(
      pLetters,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        stagger: 0.03,
        duration: 1.5,
        scrollTrigger: {
          trigger: section,
          start: "top 75%",
          end: "top 45%",
          scrub: true,
        },
      }
    );

    // --- Handle column_section animation
    const columnSection = section.querySelector(".column_section");
    const imageWrapper = columnSection?.querySelector(
      ".col_left .image_wrapper"
    );
    const contentArea = columnSection?.querySelector(".col_right");

    if (columnSection && imageWrapper && contentArea) {
      // --- Image reveal animation (top to bottom)
      gsap.fromTo(
        imageWrapper,
        { clipPath: "inset(100% 0% 0% 0%)" },
        {
          clipPath: "inset(0% 0% 0% 0%)",
          ease: "power2.out",
          duration: 1.5,
          scrollTrigger: {
            trigger: imageWrapper,
            start: "top 85%",
            end: "top 60%",
            scrub: true,
          },
        }
      );

      // --- Animate all text elements inside col_right
      const textElements = contentArea.querySelectorAll(
        "h1, h2, h3, h4, h5, h6, p, li"
      );

      textElements.forEach((el) => {
        if (el.querySelector("span.letter")) return;

        const letters = wrapLetters(el);

        gsap.fromTo(
          letters,
          { opacity: 0, y: 20 },
          {
            opacity: 1,
            y: 0,
            stagger: 0.03,
            duration: 1.5,
            scrollTrigger: {
              trigger: el,
              start: "top 90%", // start each text element sooner
              end: "top 60%",
              scrub: true,
            },
          }
        );
      });
    }
  });
}
